<template>
  <BaseWeb :logo-img="logoPhoto"
           :app-img-arr="appPhotoArr" :app-name="appName" :company="companyName" :icp-num="icpNum"
           class="many_recruit_btn" :download-path="downloadPath" :one-word="oneWord" :tow-word="towWord"></BaseWeb>
</template>

<script>
import BaseWeb from '../components/baseWeb'
export default {
  name: "elephantPartTime",
  components:{
    BaseWeb:BaseWeb
  },
  data(){
    return{
      logoPhoto:require('../assets/elephant/logo.png'),
      appPhotoArr:[
        {id:1,photo:require('../assets/elephant/one.png')},
        {id:2,photo:require('../assets/elephant/tow.png')},
        {id:3,photo:require('../assets/elephant/three.png')},
        {id:4,photo:require('../assets/elephant/four.png')},
      ],
      appName:'大象兼职',
      companyName:'上海峙莹网络科技有限公司',
      icpNum:'沪ICP备2022032260号-1',
      downloadPath:'http://apk.hotbuybuy.com/cmjz_oppo_100.apk',
      oneWord:'手机兼职赚钱软件就选大象兼职大象兼职 您的手机.兼职.赚钱.小能手。玩手机兼职做赚钱任务，轻松赚到生活费，大象兼职赚钱兼职平台，手机兼职赚钱必备。丰富的任务类型和海量任务，就在大象兼职。',
      towWord:'【新手任务赚】<br/>' +
        '新手任务专为新人定制，大象兼职传授赚钱秘笈。\n<br/>' +
        '【走路赚】\n<br/>' +
        '每天走走路，也可额外赚钱每日上线领取即可得到现金奖励，饭后走一走，坐享红包奖励。\n<br/>' +
        '【睡觉赚】\n<br/>' +
        '睡觉也能赚，睡醒就能收取奖励。\n<br/>' +
        '【吃饭赚】\n<br/>' +
        '吃饭也能赚，每日三餐都有吃饭活动，动动手指即可领取补贴哦。',
    }
  }
}
</script>

<style scoped>
.many_recruit_btn{
  --downBtn:rgb(254,200,40);
}
</style>



// WEBPACK FOOTER //
// src/components/elephantPartTime.vue